import { LOYALTY_API_BASE } from "../constants";
import { loyaltyFetch } from "../hooks/loyaltyFetch";
import { loyaltyApiDetail } from "./loyaltyApiMessage";

export function parseCouponTypeIds(rewardOrList) {
    if (!rewardOrList) return [];
    if (Array.isArray(rewardOrList)) {
        return rewardOrList.map((item) => {
            if (typeof item === "string" || typeof item === "number") return String(item);
            return String(item?.id ?? item?.coupon_type_id ?? "");
        }).filter(Boolean);
    }
    if (Array.isArray(rewardOrList.coupon_type_ids)) {
        return rewardOrList.coupon_type_ids.map(String);
    }
    if (Array.isArray(rewardOrList.coupon_types)) {
        return rewardOrList.coupon_types.map((ct) => String(ct.id)).filter(Boolean);
    }
    const nested = rewardOrList.items;
    if (Array.isArray(nested)) return parseCouponTypeIds(nested);
    return [];
}

/** Charge la reward + coupon_type_ids (fallback GET …/coupon-types). */
export async function fetchRewardForEdit(rewardId, brandName) {
    const headers = { "X-Brand": brandName };
    const res = await loyaltyFetch(`${LOYALTY_API_BASE}/rewards/${encodeURIComponent(rewardId)}`, { headers });
    const data = await res.json().catch(() => null);
    if (!res.ok) {
        throw new Error(loyaltyApiDetail(data?.detail) || `Erreur HTTP ${res.status}`);
    }

    const hasCouponTypeIdsKey = Array.isArray(data?.coupon_type_ids)
        || Array.isArray(data?.coupon_types);
    let couponTypeIds = parseCouponTypeIds(data);
    if (!hasCouponTypeIdsKey) {
        const ctRes = await loyaltyFetch(
            `${LOYALTY_API_BASE}/rewards/${encodeURIComponent(rewardId)}/coupon-types`,
            { headers },
        );
        const ctData = ctRes.ok ? await ctRes.json().catch(() => null) : null;
        couponTypeIds = parseCouponTypeIds(ctData);
    }

    return { ...data, coupon_type_ids: couponTypeIds };
}

export async function putRewardCouponTypes(rewardId, brandName, couponTypeIds) {
    const res = await loyaltyFetch(
        `${LOYALTY_API_BASE}/rewards/${encodeURIComponent(rewardId)}/coupon-types`,
        {
            method: "PUT",
            headers: { "Content-Type": "application/json", "X-Brand": brandName },
            body: JSON.stringify({ coupon_type_ids: couponTypeIds }),
        },
    );
    const data = await res.json().catch(() => null);
    if (!res.ok) {
        throw new Error(loyaltyApiDetail(data?.detail) || `Erreur HTTP ${res.status}`);
    }
    return data;
}
